import { reportReferenceDataFileService } from '../../reports/dataset/report-reference-data-file.service'
import { BaseInterceptor } from '../base'

/**
 * Intercepts requests for report reference data to retrieve from a co-located file with the webapp
 */
export class ReferenceDataRequestInterceptor extends BaseInterceptor {
  constructor (referenceDataFolder) {
    super({
      method: 'get',
      path: 'api/report/reference-data'
    })

    this.referenceDataFolder = referenceDataFolder
  }

  /**
   * On Intercept:
   * 1. Get the filename of the reference data file
   * 2. Return an updated request config with the file's URL
   *
   * @param {object} ctxt Request context
   * @param {object} ctxt.config Request config
   * @param {object} ctxt.config.params Requested params describing the desired reference data
   * @param {object} params Contextual params
   * @param {object} params.report Report
   * @returns {object} Request config
   */
  onIntercept ({ config }, { report }) {
    const { type, ...params } = config.params
    const filename = reportReferenceDataFileService.getFilename(type, params)
    if (!filename) {
      throw new Error(`No filename found for ${type} reference data`)
    }

    return {
      ...config,
      method: 'get',
      url: `${this.referenceDataFolder}/${filename}`,
      params: null
    }
  }
}
